module.exports = __webpack_public_path__ + "static/media/bottle.829ce9fd.svg";